import React from "react";
import { useEffect, useState } from "react";
import "./ModalEditTraining.scss";
import { Select, DatePicker, Input, Steps, TimePicker } from "antd";
import { Controller } from "react-hook-form";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import "../SessionCard/SessionCard.scss";
import dayjs from "dayjs";
import useTrainingEditLogic from "./logic/useTrainingEditLogic";

function ModalEditTraining({
  isModalEditOpen,
  setIsModalEditOpen,
  idTraining,
  isUpcomingTraining
}) {
  const { RangePicker } = DatePicker;
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedDates, setSelectedDates] = useState([]);
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === 1;
  const [data, setData] = useState({});
  const handleCancel = () => {
    setIsModalEditOpen(!isModalEditOpen);
    setCurrentStep(0);
  };

  const {
    selectedUsers,
    courseOptions,
    handleSubmit,
    errors,
    control,
    selectedOptionLanguage,
    watch,
    setValue,
    onUpdateTraining,
    customDateFormat
  } = useTrainingEditLogic(
    data,
    handleCancel,
    setCurrentStep,
    idTraining,
    setData,
    selectedDates,
    isUpcomingTraining,
    isModalEditOpen
  );

  const stepsItems = [
    {
      title: "Step1",
      className: "steps1",
    },
    {
      title: "Step2",
      className: "steps2",
    },
  ];

  const handleAddSession = (date, index) => {
    const newData = { ...data };

    if (newData[date]) {
      newData[date].push({
        date,
        from: null,
        to: null,
      });
      setData(newData);
    } else {
      newData[date] = [
        { date, from: null, to: null },
      ];
      setData(newData);
    }
  };

  useEffect(() => {
    const dates = watch("rangeDate");
    if (dates) {
      setSelectedDates(
        getDatesBetweenDates(watch("rangeDate")[0], watch("rangeDate")[1])
      );
    }
    return () => {
      setSelectedDates([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch("rangeDate")]);

  const nextStep = () => {
    if (!isLastStep) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleDeleteSession = (date) => {
    const newData = { ...data };
    const sessions = newData[date];
    if (sessions && sessions.length > 1) {
      sessions.pop();
      setValue(`time_${date}_${sessions.length}`, null);
      setData(newData);
    }
  };

  const prevStep = () => {
    if (!isFirstStep) {
      setCurrentStep(currentStep - 1);
    }
  };
  const getDatesBetweenDates = (startDate, endDate) => {
    const dates = [];
    startDate = dayjs(startDate).unix();
    endDate = dayjs(endDate).unix();
    while(startDate <= endDate){
      dates.push(dayjs.unix(startDate).format(customDateFormat));
      startDate += 60*60*24;
    }
    return dates;
  };

  if (!isModalEditOpen) {
    return null;
  }
  const disabledDate = (current) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return current && current.valueOf() < today.valueOf();
  };
  const SessionForm = ({ index, control, errors, date }) => {
    const [timeFieldValue, setTimeFieldValue] = useState(false);
    const [inputError, setInputError] = useState(null);
    const handleSessionChange = (from, to, date) => {
      const fromTime = from ? dayjs(`${date} ${from}`, `${customDateFormat} h:mm a`) : null;
      const toTime = to ? dayjs(`${date} ${to}`, `${customDateFormat} h:mm a`) : null;
      const fieldName = `time_${date}_${index}`;
      setTimeFieldValue([from, to]);

      const isValid = from && to;
    if (!isValid) {
      setValue(fieldName, null);
      return;
    }
    setInputError(!inputError);
      setValue(fieldName, [fromTime, toTime]);
      const newData = { ...data };
      const sessions = newData[date];
      if (sessions && sessions.length > 1) {
        sessions[index] = {
          date,
          from: fromTime?.format("h:mm a") || null,
          to: toTime?.format("h:mm a") || null,
        };

        setData(newData);
      }
      else {
        const newDataArray = { ...data };
        const sessions = newDataArray[date];
        const currentSession = sessions[index];
        currentSession.from = from;
        currentSession.to = to;
        setData(newDataArray);
      }
    };
    return (
      <div className="session-card-content-edit-training">
        <label>Session {index + 1}</label>
        <div className="session-card-time-edit-training">
          <div className="session-card-start-edit-training">
            <label>Time : </label>
            <Controller
              name={`time_${date}_${index}`}
              control={control}
              rules={{ required: "Enter Time..." }}
              render={({ field }) => (
                <TimePicker.RangePicker
                  format="h:mm a"
                  value={timeFieldValue}
                  {...field}
                  onChange={(timeValue) => {
                    setTimeFieldValue(timeValue);
                    field.onChange(timeValue);
                    const format = "h:mm a";
                    const from = timeValue?.[0]?.format(format) || null;
                    const to = timeValue?.[1]?.format(format) || null;
                    handleSessionChange(from, to, date);
                  }}
                />
              )}
            />
          {errors[`time_${date}_${index}`] && (
            <span className="error-msg" style={{ color: "red" }}>
              {errors[`time_${date}_${index}`]?.message}
            </span>
          )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div
        className={`modal-overlay-edit-training ${
          isModalEditOpen ? "modal-overlay-edit-training show" : "modal-overlay-edit-training"
        }`}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3>Update Training</h3>
          </div>
          <form>
            <Steps current={currentStep} items={stepsItems} />
            {currentStep === 0 && (
              <div className="modal-body">
                <div className="modal-cards">
                  <div className="input-group">
                    <div className="input-group-item">
                      <Controller
                        name="course"
                        control={control}
                        rules={{ required: "Select a course is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={courseOptions}
                            allowClear
                            placeholder="Select a course"
                          />
                        )}
                      />
                      {errors.course && (
                        <span className="error-msg">
                          {errors.course?.message}
                        </span>
                      )}
                    </div>
                    <div className="input-group-item">
                      <Controller
                        name="trainer"
                        control={control}
                        rules={{ required: "Select a trainer is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={selectedUsers}
                            allowClear
                            placeholder="Select a trainer"
                          />
                        )}
                      />
                      {errors.trainer && (
                        <span className="error-msg">
                          {errors.trainer?.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="input-group">
                    <div className="input-group-item">
                      <Controller
                        name="rangeDate"
                        control={control}
                        rules={{ required: "Select a range date is required" }}
                        render={({ field }) => (
                          <RangePicker
                            format="YYYY-MM-DD"
                            {...field}
                            disabledDate={disabledDate}
                          />
                        )}
                      />
                      {errors.rangeDate && (
                        <span className="error-msg">
                          {errors.rangeDate?.message}
                        </span>
                      )}
                    </div>
                    <div className="input-group-item">
                      <Controller
                        name="location"
                        control={control}
                        rules={{ required: "Select a location is required" }}
                        render={({ field }) => (
                          <Input {...field} placeholder="Select a location" />
                        )}
                      />
                      {errors.location && (
                        <span className="error-msg">
                          {errors.location?.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="input-group">
                    <div className="input-group-item">
                      <Controller
                        name="equipment"
                        control={control}
                        render={({ field }) => (
                          <Input {...field} placeholder="Enter Equipment" />
                        )}
                      />
                    </div>

                    <div className="input-group-item">
                      <Controller
                        name="language"
                        control={control}
                        rules={{ required: "Select a language is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={selectedOptionLanguage}
                            allowClear
                            placeholder="Select a language"
                          />
                        )}
                      />
                      {errors.language && (
                        <span className="error-msg">
                          {errors.language?.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="input-group">
                    <div className="input-group-item">
                      <label>Guaranteed</label>
                      <Controller
                        name="isGuaranteed"
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                          <input
                            type="checkbox"
                            checked={field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {currentStep === 0 && (
              <div className="modal-footer">
                <button
                  onClick={() => prevStep()}
                  className={isFirstStep ? "btn-disabled" : "btn-prev"}
                >
                  Previous
                </button>
                {
                  <button onClick={handleSubmit(nextStep)} className="btn-next">
                    Next
                  </button>
                }
                <button className="btn-cancel" onClick={() => handleCancel()}>
                  Cancel
                </button>
              </div>
            )}
          </form>

          <form onSubmit={handleSubmit(onUpdateTraining)}>
            {currentStep === 1 && (
              <div className="modal-step2">
                <div className="modal-step2-date">
                  <label>
                    Start : {dayjs(selectedDates[0], customDateFormat).format('DD-MM-YYYY')}
                  </label>
                  <label>
                    End :{" "}
                    {dayjs(selectedDates[selectedDates.length - 1], customDateFormat).format('DD-MM-YYYY')}
                  </label>
                </div>
                {selectedDates.map((date, index) => (
                  <div className="session-card-container" key={index}>
                    <div className="session-card-header">
                      <label>Date: {dayjs(date, customDateFormat).format('DD-MM-YYYY')}</label>
                      <div className="session-card-icons">
                        <DeleteOutlined
                          className="trashIcon"
                          onClick={() => handleDeleteSession(date)}
                        />
                        <span onClick={() => handleAddSession(date, index)}>
                          <PlusOutlined className="addIcon" />
                        </span>
                      </div>
                    </div>
                    {data[date]?.map(
                      (session, sessionIndex) => {
                        return (
                          <SessionForm
                            key={sessionIndex}
                            index={sessionIndex}
                            date={date}
                            // session={session}
                            control={control}
                            errors={errors}
                          />
                        );
                      }
                    )}
                  </div>
                ))}
              </div>
            )}

            {currentStep === 1 && (
              <div className="modal-footer">
                <button
                  onClick={() => prevStep()}
                  className={isFirstStep ? "btn-disabled" : "btn-prev"}
                >
                  Previous
                </button>
                {!isFirstStep && (
                  <button type="submit" className="btn-next">
                    Edit
                  </button>
                )}
                <button className="btn-cancel" onClick={() => handleCancel()}>
                  Cancel
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModalEditTraining;
